module.exports = __webpack_public_path__ + "static/media/uk.34cb66f2.svg";